import { format, subDays, addDays, subMonths, subYears, addMonths, addYears } from "date-fns";
import { useState, useEffect, useContext } from "react";
import { Col, Container, Form, FormGroup, Row, Nav, NavItem, Navbar, Table } from "reactstrap";
import ChartLayout from "./ChartLayout";
import SolarChartLayout from "./SolarChartLayout";
// import { utcToZonedTime } from 'date-fns-tz';
import { getDeviceId, getHistoryData } from "../api/api";
import Spinner from "./Spinner";
import { formatValue, formatValueDetail, idExists } from "../utils/NumberUtils";
import DatePicker from "react-datepicker"
import 'react-datepicker/dist/react-datepicker.css'
import { ja } from "date-fns/locale";
import ChartLayout1 from "./ChartLayout1";
import SolarChartLayout1 from "./SolarChartLayout1";
import Download from "../utils/Download";
import { useHistory } from "react-router-dom";
import { SchoolContext } from "../context/SchoolContext";

const Graph = ({ selectedRange }) => {

    const { schoolList, setSchool } = useContext(SchoolContext);
    const [daterange, setDateRange] = useState('day');
    const [graphData, setGraphData] = useState();
    const [activeTab, setActiveTab] = useState("1");
    const [isLoading, setIsLoading] = useState(false);
    const [changeDate, setChangeDate] = useState(new Date().toISOString().split("T")[0]);
    const [currentDay] = useState(new Date().toISOString().split("T")[0]);
    const currentMonth = format(new Date(), 'yyyy-MM');
    const currentYear = format(new Date(), 'yyyy')
    const [canPrev, setCanPrev] = useState(true);
    const [canNext, setCanNext] = useState(false);
    const authToken = localStorage.getItem('accessToken');
    const [deviceId, setDeviceId] = useState(null);
    const history = useHistory();
    const pathname = history["location"].pathname
    const school_id = Number(pathname.split('/').pop());

    // const convertToZonedTime = (date) => {
    //     return utcToZonedTime(date.toISOString(), 'Asia/Tokyo');
    // };
    const activationDate = schoolList.length > 0 && idExists(schoolList, school_id) && schoolList[school_id - 1].operation_start_date;
    const [dayDetail, setdayDetail] = useState();
    const handleDateRange = (e) => {
        setDateRange(e);
        const newDate = format(new Date(), e === 'year' ? 'yyyy' : 'yyyy-MM' + ((e === 'day' || e === 'min') ? '-dd' : ''));
        setChangeDate(newDate)
    }

    useEffect(() => {
        if (typeof selectedRange === 'string') {
            setDateRange(selectedRange);
        }
    }, [selectedRange]);

    useEffect(() => {
        setIsLoading(true)
        const Value = JSON.parse(localStorage.getItem('schools'));
        const schoolObj = { id: school_id };
        if (Value && Value !== null && Value.some(obj => obj.id === schoolObj.id)) {
            setDeviceId(Value.find(obj => obj.id === schoolObj.id).device_id);
            setSchool(Number(school_id));
            setIsLoading(false);
        } else {
            if (schoolList.length > 0) {
                if (idExists(schoolList, school_id)) {
                    setSchool(school_id);
                    const Id = async () => {
                        const res = await getDeviceId(schoolList[school_id - 1].place_id, authToken);
                        if (res && res.sems_device_id) {
                            const value = localStorage.getItem('schools');
                            const schools = value ? JSON.parse(value) : [];
                            const schoolObj = { id: school_id, device_id: res.sems_device_id };
                            schools.push(schoolObj);
                            localStorage.setItem('schools', JSON.stringify(schools));
                            setDeviceId(res.sems_device_id)
                        }
                        setIsLoading(false);
                    }
                    Id();
                } else {
                    history.push('/home')
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authToken, history, schoolList, school_id])

    useEffect(() => {
        if (deviceId !== null) {
            setIsLoading(true);
            const controller = new AbortController();
            const signal = controller.signal;

            const HistoryData = async (signal) => {
                const formatDate = format(new Date(), daterange === 'year' ? 'yyyy' : 'yyyy-MM' + (daterange === 'day' || daterange === 'min' ? '-dd' : ''));
                const response = await getHistoryData(authToken, daterange === 'min' ? 'minute' : daterange, formatDate, deviceId, signal);
                setIsLoading(false);
                if (daterange === 'min') {
                    setdayDetail(response);
                } else {
                    setGraphData(response);
                }
            }
            HistoryData(signal);

            return () => {
                controller.abort();
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [daterange, deviceId])

    useEffect(() => {
        if (daterange === 'day' || daterange === "min") {
            if (Date.parse(activationDate) - Date.parse(changeDate) === 0) {
                setCanPrev(false);
                setCanNext(true);
            } else {

                if (Date.parse(currentDay) - Date.parse(changeDate) > 0) {
                    setCanPrev(true)
                    setCanNext(true)
                }

                if (Date.parse(currentDay) - Date.parse(changeDate) <= 0) {
                    setCanPrev(true)
                    setCanNext(false)
                }
            }
        }
        if (daterange === 'month') {
            if (Date.parse(format(Date.parse(activationDate), "yyyy-MM")) - Date.parse(changeDate) === 0) {
                setCanNext(true);
                setCanPrev(false);
            } else {
                if (Date.parse(currentMonth) - Date.parse(changeDate) > 0) {
                    setCanPrev(true)
                    setCanNext(true)
                }

                if (Date.parse(currentMonth) - Date.parse(changeDate) <= 0) {
                    setCanPrev(true)
                    setCanNext(false)
                }
            }
        }
        if (daterange === 'year') {
            if (Date.parse(format(Date.parse(activationDate), "yyyy")) - Date.parse(changeDate) === 0) {
                setCanPrev(false);
                if (Date.parse(currentYear) - Date.parse(format(Date.parse(activationDate), "yyyy")) > 0) {
                    setCanNext(true);
                } else { setCanNext(false) }
            }
            else {
                if (Date.parse(currentYear) - Date.parse(changeDate) > 0) {
                    setCanPrev(true)
                    setCanNext(true)
                }

                if (Date.parse(currentYear) - Date.parse(changeDate) <= 0) {
                    setCanPrev(true)
                    setCanNext(false)
                }
            }
        }

        //eslint-disable-next-line
    }, [changeDate]);

    const handlePrev = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (daterange === "day" || daterange === 'min') {
            const tmpDate = (format(subDays(new Date(changeDate), 1), 'yyyy-MM-dd'))
            setChangeDate(tmpDate)
            const response = await getHistoryData(authToken, daterange === 'min' ? 'minute' : daterange, tmpDate, deviceId);
            if (daterange === 'min') {
                setdayDetail(response);
                setIsLoading(false);
            } else {
                setGraphData(response);
                setIsLoading(false);
            }
        }
        if (daterange === "month") {
            const tmpDate = (format(subMonths(new Date(changeDate), 1), 'yyyy-MM'))
            setChangeDate(tmpDate)
            const response = await getHistoryData(authToken, daterange, tmpDate, deviceId);
            setGraphData(response);
            setIsLoading(false);
        }
        if (daterange === "year") {
            const tmpDate = (format(subYears(new Date(changeDate), 1), 'yyyy'))
            setChangeDate(tmpDate)
            const response = await getHistoryData(authToken, daterange, tmpDate, deviceId);
            setGraphData(response);
            setIsLoading(false);
        }
    };
    const handleNext = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (daterange === "day" || daterange === 'min') {
            const tmpDate = (format(addDays(new Date(changeDate), 1), 'yyyy-MM-dd'))
            setChangeDate(tmpDate)
            const response = await getHistoryData(authToken, daterange === 'min' ? 'minute' : daterange, tmpDate, deviceId);
            if (daterange === 'min') {
                setdayDetail(response);
                setIsLoading(false);
            } else {
                setGraphData(response);
                setIsLoading(false);
            }
        }
        if (daterange === "month") {
            const tmpDate = (format(addMonths(new Date(changeDate), 1), 'yyyy-MM'))
            setChangeDate(tmpDate)
            const response = await getHistoryData(authToken, daterange, tmpDate, deviceId);
            setGraphData(response);
            setIsLoading(false);
        }
        if (daterange === "year") {
            const tmpDate = (format(addYears(new Date(changeDate), 1), 'yyyy'))
            setChangeDate(tmpDate)
            const response = await getHistoryData(authToken, daterange, tmpDate, deviceId);
            setGraphData(response);
            setIsLoading(false);
        }
    }

    const handleDateChange = async (e) => {
        setIsLoading(true);
        let newDate;
        if (e === null) {
            newDate = format(new Date(), daterange === 'year' ? 'yyyy' : 'yyyy-MM' + ((daterange === 'day' || daterange === "min") ? '-dd' : ''));
        } else {
            newDate = format(new Date(e), daterange === 'year' ? 'yyyy' : 'yyyy-MM' + ((daterange === 'day' || daterange === "min") ? '-dd' : ''));
        }
        setChangeDate(newDate);
        const response = await getHistoryData(authToken, daterange === 'min' ? 'minute' : daterange, newDate, deviceId);
        if (daterange === 'min') {
            setdayDetail(response);
            setIsLoading(false);
        } else {
            setGraphData(response);
            setIsLoading(false);
        }
    };
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const tableWrapper = document.querySelector('.power__history');
            const tableOffset = tableWrapper ? tableWrapper.offsetTop : 0;
            const navbar = document.getElementById('topnav');
            const navbarOffset = navbar ? navbar.offsetTop : 0;
            const mobilenavbar = document.getElementById('topnavMobile');
            const navbarHeight = navbarOffset > 0 ? navbar.offsetHeight : mobilenavbar.offsetHeight;
            setIsSticky(window.pageYOffset + navbarHeight > tableOffset);
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return <>
        {isLoading ? <Spinner /> :
            <Container fluid>
                <Col className="h-100 graphContent">
                    <Row style={{ 'justifyContent': 'center' }}>
                        <Navbar className="justify-content-center">
                            <Nav>
                                <NavItem className="text_graph">
                                    電力管理
                                </NavItem>
                            </Nav>
                        </Navbar>
                        {/* Form  */}
                        <Col md={12} className=" pt-2">
                            <Form>
                                <FormGroup row style={{ 'justifyContent': 'center' }} className="d-flex flex-column align-content-center">
                                    <Col md={8} className="d-flex flex-row justify-content-between graphTopMenu">
                                        <Col className="text-center border-col">
                                            <span className={`text_graph graph_change ${(activeTab === "4") ? 'activeTab' : ""}`} value="min" onClick={() => { handleDateRange('min'); setActiveTab("4"); }}>日(詳細)</span>
                                        </Col>
                                        <Col className="text-center border-col">
                                            <span className={`text_graph graph_change ${(activeTab === "1") ? 'activeTab' : ""}`} value="day" onClick={() => { handleDateRange('day'); setActiveTab("1"); }}>日</span>
                                        </Col>
                                        <Col className="text-center border-col">
                                            <span className={`text_graph graph_change ${(activeTab === "2") ? 'activeTab' : ""}`} value="month" onClick={() => { handleDateRange('month'); setActiveTab("2"); }}>月</span>
                                        </Col>
                                        <Col className="text-center border-col">
                                            <span className={`text_graph graph_change ${(activeTab === "3") ? 'activeTab' : ""}`} value="year" onClick={() => { handleDateRange('year'); setActiveTab("3"); }}>年</span>
                                        </Col>
                                        {/* <Col className="text-center border-col">
                                            <span className={`text_graph graph_change ${(activeTab === "4") ? 'activeTab' : ""}`} value="week" onClick={() => { handleDateRange('week'); setActiveTab("4"); }}>合計</span>
                                        </Col> */}
                                    </Col>
                                </FormGroup>
                            </Form>
                        </Col>
                        <div className=' datediv'>
                            {/* <button className={canPrev ? "previous dot" : "d-visib"}
                                onClick={handlePrev}

                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" className="bi bi-chevron-left" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                                </svg>
                            </button> */}
                            <button className={canPrev ? "pointer-image" : "d-visib"}
                                onClick={handlePrev}>
                                <img src="/img/prev.png" alt="prev" />
                            </button>

                            <span className="time_graph marginDateR">
                                {daterange === 'year' ?
                                    <DatePicker className="reactDatepicker"
                                        type='date'
                                        label=""
                                        portalId="root-portal"
                                        value={changeDate.substring(0, 4) + '年'}
                                        selected={Date.parse(changeDate)}
                                        locale={ja}
                                        onChange={handleDateChange}
                                        maxDate={new Date()}
                                        minDate={new Date(new Date(activationDate).getFullYear(), 0, 1)}
                                        showYearPicker
                                        dateFormat="yyyy"
                                        yearItemNumber={2}
                                    />
                                    :
                                    daterange === 'month' ? <DatePicker className="reactDatepicker"
                                        type='date'
                                        portalId="root-portal"
                                        value={changeDate.substring(0, 4) + '年' + changeDate.substring(5, 7) + '月'}
                                        selected={Date.parse(changeDate)}
                                        locale={ja}
                                        onChange={handleDateChange}
                                        maxDate={new Date()}
                                        minDate={new Date(new Date(activationDate).getFullYear(), new Date(activationDate).getMonth(), 1)}
                                        dateFormat="MM/yyyy"
                                        showMonthYearPicker
                                    />
                                        :
                                        <DatePicker className="reactDatepicker"
                                            type='date'
                                            portalId="root-portal"
                                            value={changeDate.substring(0, 4) + '年' + changeDate.substring(5, 7) + '月' + changeDate.substring(8, 10) + '日'}
                                            selected={Date.parse(changeDate)}
                                            locale={ja}
                                            onChange={handleDateChange}
                                            maxDate={new Date()}
                                            minDate={new Date(activationDate)}
                                        // showYearDropdown
                                        // scrollableYearDropdown
                                        />}
                            </span>

                            {/* <button className={canNext ? "next dot marginLeft3  " : "d-visib next dot marginLeft3"} onClick={handleNext}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                                </svg>
                            </button> */}
                            <button className={canNext ? "pointer-image" : "d-visib"}
                                onClick={handleNext}>
                                <img src="/img/next.png" alt="next" />
                            </button>
                        </div>
                        <div className=' datedivMobile'>
                            <span className="time_graph">
                                {daterange === 'year' ?
                                    <DatePicker className="reactDatepicker"
                                        type='date'
                                        label=""
                                        portalId="root-portal"
                                        value={changeDate.substring(0, 4) + '年'}
                                        selected={Date.parse(changeDate)}
                                        locale={ja}
                                        onChange={handleDateChange}
                                        maxDate={new Date()}
                                        minDate={new Date(new Date(activationDate).getFullYear(), 0, 1)}
                                        showYearPicker
                                        dateFormat="yyyy"
                                        yearItemNumber={2}
                                    />
                                    :
                                    daterange === 'month' ? <DatePicker className="reactDatepicker"
                                        type='date'
                                        portalId="root-portal"
                                        value={changeDate.substring(0, 4) + '年' + changeDate.substring(5, 7) + '月'}
                                        selected={Date.parse(changeDate)}
                                        locale={ja}
                                        onChange={handleDateChange}
                                        maxDate={new Date()}
                                        minDate={new Date(new Date(activationDate).getFullYear(), new Date(activationDate).getMonth(), 1)}
                                        dateFormat="MM/yyyy"
                                        showMonthYearPicker
                                    />
                                        :
                                        <DatePicker className="reactDatepicker"
                                            type='date'
                                            portalId="root-portal"
                                            value={changeDate.substring(0, 4) + '年' + changeDate.substring(5, 7) + '月' + changeDate.substring(8, 10) + '日'}
                                            selected={Date.parse(changeDate)}
                                            locale={ja}
                                            onChange={handleDateChange}
                                            maxDate={new Date()}
                                            minDate={new Date(activationDate)}
                                        // showYearDropdown
                                        // scrollableYearDropdown
                                        />}
                            </span>
                            {/* <span className=" time_graph datepicker">
                                {daterange === 'day' ? changeDate.substring(0, 4) + '年' + changeDate.substring(5, 7) + '月' + changeDate.substring(8, 10) + '日' : daterange === 'year' ? changeDate.substring(0, 4) + '年' : daterange === 'month' ? changeDate.substring(0, 4) + '年' + changeDate.substring(5, 7) + '月' : changeDate.substring(0, 4) + '年' + changeDate.substring(5, 7) + '月' + changeDate.substring(8, 10) + '日'}
                                <Input type="date"
                                    onChange={handleDateChange}
                                    value={changeDate}
                                    max={format(new Date(), "yyyy-MM-dd")}
                                    min={format(Date.parse(activationDate), "yyyy-MM-dd")}
                                />

                            </span> */}
                            <div className="arrows">
                                <button className={canPrev ? "previous dot" : "d-none"}
                                    onClick={handlePrev}

                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" className="bi bi-chevron-left" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                                    </svg>
                                </button>



                                <button className={canNext ? "next dot" : "d-none"} onClick={handleNext}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        {/* System Info */}
                        {/* <Col md={3} className=" text-center text-yellow">
                    <p className="m-0 pt-1">モード: 自家消費</p>
                </Col> */}
                    </Row>
                    {/* Chart1 */}
                    <Row className="bg-gradient graphPage firstGraph">
                        <Col md={12}>
                            {daterange === 'min' ? <>{dayDetail && (dayDetail !== null) && Object.keys(dayDetail).length !== 0 ? <ChartLayout1 posts={dayDetail}
                                type={daterange}
                                isAuto={false}
                                date={changeDate}
                            /> : <p className="no__data">データがない。</p>}
                            </> :
                                <>{graphData && (graphData !== null) && Object.keys(graphData).length !== 0 ? <ChartLayout posts={graphData}
                                    type={daterange}
                                    isAuto={false}
                                    date={changeDate}
                                /> : <p className="no__data">データがない。</p>}</>}
                        </Col>
                    </Row>
                    {/* Chart2 */}
                    <Row className="bg-gradient graphPage secondGraph">
                        <Col md={12}>
                            {daterange === 'min' ? <>{dayDetail && (dayDetail !== null) && Object.keys(dayDetail).length !== 0 ? <SolarChartLayout1 posts={dayDetail}
                                type={daterange}
                                isAuto={false}
                                date={changeDate}
                            /> : <p className="no__data">データがない。</p>}
                            </> : <>{graphData && (graphData !== null) && Object.keys(graphData).length !== 0 ? <SolarChartLayout posts={graphData}
                                type={daterange}
                                isAuto={false}
                                date={changeDate}
                            /> : <p className="no__data">データがない。</p>}</>}
                        </Col>
                    </Row >
                    <Col className="d-flex flex-row-reverse">
                        <Download daterange={daterange} changeDate={changeDate} deviceId={deviceId} graphData={graphData} dayDetail={dayDetail} />
                    </Col>
                    <Row>
                        {/* <Table className="graph__table"> */}
                        <div className={`power__history ${isSticky ? 'sticky' : ''}`}><Table className='graph__table'>
                            {daterange === 'min' ?
                                <>
                                    <thead>
                                        <th>期間</th>
                                        <th>需要電力<br />[kW]</th>
                                        <th>発電電力<br />[kW]</th>
                                        <th>買電力(+)/売電力(-)<br />[kW]</th>
                                        <th>蓄電池放電電力(+)/蓄電池充電電力(-)<br />[kW]</th>
                                        <th>蓄電池充電率<br />[%]</th>
                                        <th>消費電力<br />[kW]</th>
                                        <th>日射強度<br />[kW/m²]</th>
                                        <th>温度<br />[°C]</th>
                                    </thead>
                                    <tbody>
                                        {
                                            dayDetail && dayDetail['datetime'] && dayDetail['datetime'].map((data, index) =>
                                                <tr>
                                                    <td>{data.slice(11, 16)}</td>
                                                    <td>{dayDetail['demand_power'] ? formatValueDetail(dayDetail['demand_power'][index]) : "---"}</td>
                                                    <td>{formatValueDetail(dayDetail['pv_power'][index])}</td>
                                                    <td>{formatValueDetail(dayDetail['mmr_power'][index])}</td>
                                                    <td>{formatValueDetail(dayDetail['bt_power'][index])}</td>
                                                    <td>{(typeof (dayDetail['soc'][index]) === 'string') ? (dayDetail['soc'][index]) : (dayDetail['soc'][index]).toFixed(0)}</td>
                                                    <td>{formatValueDetail(dayDetail['consumption_power'][index])}</td>
                                                    <td>{(typeof (dayDetail['solar_radiation'][index]) === 'string') ? (dayDetail['solar_radiation'][index]) : formatValueDetail((dayDetail['solar_radiation'][index]), 1)}</td>
                                                    <td>{(typeof (dayDetail['temperature'][index]) === 'string') ? (dayDetail['temperature'][index]) : (dayDetail['temperature'][index]).toFixed(1)}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </> :
                                <><thead>
                                    <tr>
                                        <th>期間</th>
                                        <th>需要電力量<br />[kWh]</th>
                                        <th>発電量<br />[kWh]</th>
                                        <th>買電量<br />[kWh]</th>
                                        <th>売電量<br />[kWh]</th>
                                        <th>蓄電池放電量<br />[kWh]</th>
                                        <th>蓄電池充電量<br />[kWh]</th>
                                        <th>蓄電池充電率<br />[%]</th>
                                        <th>消費電力量<br />[kWh]</th>
                                        <th>日射量<br />[kWh/m²]</th>
                                        <th>温度<br />[°C]</th>
                                    </tr>

                                </thead>
                                    <tbody>
                                        {
                                            graphData && graphData['power_gene_str'] && graphData['power_gene_str'].map((data, index) =>
                                                <tr>
                                                    {daterange && daterange === 'day' ? index < 10 ? <td>0{index}:00</td> : <td>{index}:00</td> : <td>{index + 1}</td>}
                                                    <td>{graphData['demand_power'] ? formatValue(graphData['demand_power'][index]) : "---"}</td>
                                                    <td>{formatValue(data)}</td>
                                                    <td>{formatValue(graphData['recv_power'][index])}</td>
                                                    <td>{formatValue(graphData['trans_power'][index])}</td>
                                                    <td>{formatValue(graphData['dischrg_power'][index])}</td>
                                                    <td>{formatValue(graphData['chrg_power'][index])}</td>
                                                    <td>{(typeof (graphData['soc'][index]) === 'string') ? (graphData['soc'][index]) : (graphData['soc'][index]).toFixed(0)}</td>
                                                    <td>{formatValue(graphData['consumption_power'][index])}</td>
                                                    <td>{(typeof (graphData['solar_radiation'][index]) === 'string') ? (graphData['solar_radiation'][index]) : formatValue((graphData['solar_radiation'][index]), 1)}</td>
                                                    <td>{(typeof (graphData['temperature'][index]) === 'string') ? (graphData['temperature'][index]) : (graphData['temperature'][index]).toFixed(1)}</td>
                                                </tr>
                                            )
                                        }

                                    </tbody></>}

                        </Table></div>
                    </Row>
                </Col>
            </Container >
        }
    </>
};

export default Graph;